import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { RefreshTokenServicePathConst } from '../../app-config.const';
import { RedirectLoginServicePathConst } from '../../pages/redirect/shared/const';
import { LoginByTokenModel, RefreshTokenModel, RefreshTokenReqModel } from '../auth/model';
import { BaseService } from '../base-service/service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private router: Router, private baseService: BaseService) {
	}

	private static navigateToFO() {
		window.location.href = environment.foURL;
	}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				(event: HttpEvent<any>) => {
					/* client-side error */
					if (event instanceof HttpResponse) {
						if (event.body) {
							let message = null;

							switch (event.body.status) {
								case 401:
									message = 'Authorization failed';
									break;

								case 403:
									message = 'Forbidden';
									ErrorInterceptor.navigateToFO();
									break;
							}

							if (message) {
								console.error(message);
							}
						}
					}
				},
				(err: any) => {
					/* server-side error */
					if (err instanceof HttpErrorResponse) {
						let message = 'Unknown status error';

						switch (err.status) {
							case 401:
								message = 'Unauthorized';

								/**
								 *  code: 11002 is an errorCode which tells us that the API can't
								 *  be accessed because unauthorized
								 */
								if (err.error.errorCode === 11002) {
									this.navigateToPath();
								} else
									/**
									 *  code: 11006 is an errorCode which tells us that the API can't
									 *  be accessed because user already logout
									 */
								if (err.error.errorCode === 11006) {
									localStorage.clear();
									return ErrorInterceptor.navigateToFO();
								} else {
									this.refreshTokenService(err);
								}
								break;

							case 403:
								message = 'Forbidden';
								ErrorInterceptor.navigateToFO();
								break;

							default:
								break;
						}

						console.error(message);
					}
				}
			)
		);
	}

	private refreshTokenService(err: HttpErrorResponse) {
		if (err.url !== RefreshTokenServicePathConst) {
			const accessToken = new RefreshTokenReqModel();

			accessToken.accessToken = localStorage.getItem(
				'superAppsBack.accessToken'
			);
			accessToken.refreshToken = localStorage.getItem(
				'superAppsBack.refreshToken'
			);
			accessToken.azureToken = localStorage.getItem('superAppsBack.azureToken');

			const bodyReq = new RefreshTokenReqModel().clone(accessToken);

			this.baseService
				.postData(RefreshTokenServicePathConst, bodyReq, RefreshTokenModel)
				.subscribe(
					(resp) => {
						if (resp) {
							new RefreshTokenModel().storeRefreshTokenToLocalStorage(resp);

							this.getUserDetail();
						}
					},
					(_err) => {
						localStorage.clear();
						ErrorInterceptor.navigateToFO();
					}
				);
		}
	}

	private getUserDetail() {
		this.baseService
			.getData(RedirectLoginServicePathConst, LoginByTokenModel)
			.subscribe((resp: LoginByTokenModel) => {
				new LoginByTokenModel().storeAuthToLocalStorage(resp);

				this.navigateToPath();
			});
	}

	private navigateToPath() {
		this.router.navigate(['/secure/home']);
	}
}
